import { CREATE_ROLE, GET_ROLE, ROLE_DETAIL, ROLE_ERROR } from "../types";
import roleService from "reduxStore/service/roleService";
import strings from "translate/language";
import { errorToast, unAuthorizedError } from "utils/httpClient";

export const getRoleList = (item) => async (dispatch) => {
  try {
    const res = await roleService.getRoleList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_ROLE,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_ROLE,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const createRole = (item) => async (dispatch) => {
  try {
    const res = await roleService.createRole(item);
    if (res.data.status === 200) {
      dispatch({
        type: CREATE_ROLE,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const roleDetail = (item) => async (dispatch) => {
  try {
    const res = await roleService.roleDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: ROLE_DETAIL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
